/**
 * <TutorStudentRowSkeleton> — la forme d'une ligne de « Mes élèves » pendant le chargement.
 *
 * L'avatar, le nom et une matière, sur la ligne de `<TutorStudentRow>` (sa géométrie, importée et non
 * recopiée). Resserrée, la colonne étroite pose la matière sous le nom, comme la ligne le fait faute de place.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Skeleton } from "../../atoms/Skeleton"
import { SubjectBadgeSkeleton } from "../../atoms/SubjectBadge/SubjectBadgeSkeleton"
import { CardListRow } from "../../molecules/CardList"
import { TUTOR_STUDENT_AVATAR_SIZE, TUTOR_STUDENT_COMPACT_AVATAR_SIZE } from "./TutorStudentRow"

/** `compact` : la ligne resserrée de la colonne des élèves (son visage plus petit, ses matières sous son nom). */
export function TutorStudentRowSkeleton(props: { compact?: boolean }) {
    const { compact = false } = props
    return (
        <CardListRow>
            <Row gap="3" align="center">
                <Skeleton
                    shape="circle"
                    size={compact ? TUTOR_STUDENT_COMPACT_AVATAR_SIZE : TUTOR_STUDENT_AVATAR_SIZE}
                />
                <Row gap="2" align="center" style={styles.body}>
                    <Skeleton textSize="text-md" width={compact ? 90 : 130} />
                    <SubjectBadgeSkeleton />
                </Row>
            </Row>
        </CardListRow>
    )
}

const styles = StyleSheet.create((theme) => ({
    // Comme la ligne : la matière passe sous le nom faute de place (la colonne resserrée).
    body: { flex: 1, minWidth: 0, flexWrap: "wrap", rowGap: theme.spacing["1"] },
}))
